import { create } from "zustand";

interface KnowledgeGraphState {
	/** エージェントが記事を作成・編集・削除するたびに増える。ナレッジグラフのタブはこれが変わると読み込み直す。 */
	revision: number;
	markChanged: () => void;
}

export const useKnowledgeGraphStore = create<KnowledgeGraphState>((set) => ({
	revision: 0,
	markChanged: () => set((state) => ({ revision: state.revision + 1 })),
}));
